import {
    HTMLAttributes,
    ReactElement
} from "react";
import Dropdown from "./dropdown";
import Textarea from "./textarea";
import { Reply } from "../../assets";
interface Props extends HTMLAttributes<HTMLElement> {
    question: string;
    items: any;
    myStyle?: string;
    description?: string;
    value?:string

}
export function Questionnaire({ question, items, myStyle, description , value }: Props): ReactElement {
    return (
        <div className={`${myStyle && myStyle} questionnaire`}>
            <div className="questionnaire-qu-an">
                <span className="question"><span className="circle"></span>{question}</span>
                <Dropdown objectList items={items} iconBorder displayEmpty myStyle="answer inquery-dropdown w-48 " lable="" placeholder="  انتخاب کنید " value="0" onChange={(e: any) => { }} />
            </div>

            {value && 
            <div className="questionnaire-description-box">

<Reply color="#000000" myStyle="reply"/>
                <Textarea myStyle="description" placeholder="توضیح دهید: چه رشته یا رشته های ورزشی فعالیت دارید؟" value="" onChange={() => { }} />
            </div>
            
            }
        </div>
    )
}
export default Questionnaire;
